/**
 * 数据整合方式（用于Data Calculation）
 */
export enum DataCalculation {
  /**
   * 聚合（通用）
   */
  Aggregated = 'aggregated',
  /**
   * 拆分（通用）
   */
  Separate = 'separate',
  /**
   * 按日期拆分
   */
  SeparateByDate = 'date',
  /**
   * 按地区拆分（仅用于Region Settings、Country Settings）
   */
  SeparateByRegion = 'region',
  /**
   * 按国家拆分（仅用于Region Settings、Country Settings）
   */
  SeparateByCountry = 'market',
  /**
   * 按主品类拆分（仅用于Genre Settings）
   */
  SeparateByGenre = 'parentGenre',
  /**
   * 按副品类拆分（仅用于Genre Settings）
   */
  SeparateBySubGenre = 'subGenre',
}

/**
 * 数据统计方式（用于Data Amount）
 */
export enum DataMethod {
  /**
   * Export all data
   * 导出所有数据
   */
  ExportAllData = 'selectAll',
  /**
   * Select Top
   * 导出前n条数据（前n条数据是指某个维度的前n条，并不是列表数据中的前n条，比如下载游戏数据，如果按日期、地区、品类拆分的话，同一个游戏就会有多条数据，这里导出前n条数据意思就是导出前n个游戏的数据，因为这里维度是游戏）
   */
  SelectTop = 'selectTop',
  /**
   * 导出页面宽表勾选的数据（跟Select Top同理，并不一定是一对一的关系）
   */
  ExportSelected = 'checkedLines',
}
